import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
})

export interface SavedEstimate {
  id: string
  service: string
  inputs: Record<string, unknown>
  result: Record<string, unknown>
  created_at: string
  expires_at: string | null
}

export async function saveEstimate(
  service: string,
  inputs: Record<string, unknown>,
  result: Record<string, unknown>,
): Promise<{ id: string; url: string }> {
  const { data } = await api.post('/api/estimates', { service, inputs, result })
  return data
}

export async function getEstimate(id: string): Promise<SavedEstimate | null> {
  try {
    const { data } = await api.get(`/api/estimates/${id}`)
    return data
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 404) return null
    if (axios.isAxiosError(err) && err.response?.status === 410) {
      throw new Error('This estimate has expired and is no longer available.')
    }
    throw err
  }
}
